// AUTO-GENERATED from docs/docs/fastlane/user-support/fastlane-user-manual-combined.md.
// Do not edit by hand. Re-run scripts/generate-user-guide-sections.py.


import type { Section } from "../../types";
import tablet_operationsSection from "./tablet-operations";

export const TABLET_SECTIONS: Section[] = [
	tablet_operationsSection,
];
